import { useEffect, useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";

const VIDEO_ID = "otoW1ybenFc";

export const MusicPlayer = () => {
  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [unmuted, setUnmuted] = useState(false);

  useEffect(() => {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    window.onYouTubeIframeAPIReady = () => {
      playerRef.current = new window.YT.Player("yt-music-frame", {
        videoId: VIDEO_ID,
        playerVars: { autoplay: 1, mute: 1, loop: 1, playlist: VIDEO_ID, controls: 0, start: 11 },
        events: {
          onReady: (e) => {
            e.target.mute();
            e.target.playVideo();
            setPlaying(true);
          },
        },
      });
    };
  }, []);

  useEffect(() => {
    const unlock = () => {
      const p = playerRef.current;
      if (p && p.unMute) {
        p.unMute();
        p.setVolume(70);
        p.playVideo();
        setUnmuted(true);
        setPlaying(true);
      }
      window.removeEventListener("pointerdown", unlock);
    };
    window.addEventListener("pointerdown", unlock);
    return () => window.removeEventListener("pointerdown", unlock);
  }, []);

  const toggle = () => {
    const p = playerRef.current;
    if (!p || !p.getPlayerState) return;
    if (!unmuted) {
      p.unMute();
      p.setVolume(70);
      p.playVideo();
      setUnmuted(true);
      setPlaying(true);
      return;
    }
    if (p.getPlayerState() === 1) {
      p.pauseVideo();
      setPlaying(false);
    } else {
      p.playVideo();
      setPlaying(true);
    }
  };

  return (
    <>
      <div
        data-testid="music-player-frame"
        className="fixed bottom-0 left-0 w-px h-px overflow-hidden opacity-0 pointer-events-none"
        aria-hidden="true"
      >
        <div id="yt-music-frame" />
      </div>
      <button
        data-testid="music-toggle-btn"
        onClick={toggle}
        aria-label={unmuted ? (playing ? "Pause music" : "Play music") : "Unmute music"}
        className="fixed bottom-5 right-5 z-50 btn-gold rounded-full px-4 py-3 flex items-center gap-2 text-sm font-semibold shadow-lg"
      >
        {unmuted && playing ? (
          <Music className="w-4 h-4 animate-pulse" />
        ) : (
          <VolumeX className="w-4 h-4" />
        )}
        <span className="hidden sm:inline">
          {unmuted ? (playing ? "Now Playing" : "Play Music") : "Tap for Music"}
        </span>
      </button>
    </>
  );
};
